// extracted by mini-css-extract-plugin
module.exports = {"pretitle":"Pretitle-module--pretitle--GPnmm"};